module.exports = __webpack_public_path__ + "static/media/pied-piper-hat.445a6365.svg";